module.exports = __webpack_public_path__ + "img/icons8-city.4db816bc.svg";